export default [
    {
        description: '',
        image: 'https://www.airasia.com/aa/bigpay/images/BigPay-Tips-save-more.png',
        imagePosition: 'left',
        text: 'Nikmati pembayaran tanpa tunai di seluruh dunia dengan BigPay dan jimat untuk penerbangan, hotel, perjalanan, dan banyak lagi! Terokai tawaran perjalanan dan gaya hidup yang sesuai dengan anda, dan tempah sekarang untuk menikmati pengalaman yang lancar dengan BigPay di aplikasi AirAsia MOVE.',
        title: 'Nikmati Penerbangan Murah dan Jimat Lebih Apabila Anda Bercuti Dengan BigPay!'
      },
      {
        description: '',
        image: 'https://www.airasia.com/aa/bigpay/images/BigPay-Tips-cheap-currency-exchange.png',
        imagePosition: 'Right',
        text: 'Dengan kadar pertukaran masa terkini, anda mendapat tawaran terbaik dengan BigPay apabila melakukan transaksi di luar negara, termasuk pengeluaran tunai dan pemindahan antarabangsa. Ia diterima di seluruh dunia dan dilengkapi dengan ciri keselamatan tambahan.',
        title: 'Tukaran Matawang Asing Terbaik Dengan BigPay'
      },
      {
        description: '',
        image: 'https://www.airasia.com/aa/bigpay/images/BigPay-Tips-virtual-card.png',
        imagePosition: 'left',
        text: 'Kad BigPay maya anda akan diaktifkan sebaik sahaja permohonan anda diluluskan. Anda boleh mula menggunakan kad maya ini untuk pembelian atas talian anda dengan serta merta. Anda tidak perlu menunggu kad fizikal untuk memulakan transaksi. Cepat dan bebas masalah!',
        title: 'Kad Maya Terbaik Untuk Semua Belian Anda'
      },
      {
        description: '',
        image: 'https://www.airasia.com/aa/bigpay/images/BigPay-Tips-travel-cheaper.png',
        imagePosition: 'Right',
        text: 'Anda dapat mata ganjaran AirAsia setiap kali anda menggunakan kad BigPay, tanpa mengira mata wang transkasi. Mata ganjaran ini boleh digunakan untuk menebus sepenuh atau membayar sebahagian daripada pembelian masa depan untuk penerbangan AirAsia, perkhidmatan serta produk lain.',
        title: 'Kumpul Mata Ganjaran Dan Lebihkan Penjimatan'
      },
    ]